import React, { useEffect, useState } from 'react';

import { SiteCoreDictionary } from '../types';

interface CountdownProps {
    countdown: number;
    onClose: () => void;
    dictionary: SiteCoreDictionary;
}

const Countdown = ({ countdown, onClose, dictionary }: CountdownProps) => {
    const [remainingTimeMs, setRemainingTimeMs] = useState<number>(countdown);
    const { messageSecondLeft } = dictionary;

    useEffect(() => {
        if (remainingTimeMs <= 0) {
            onClose();
            return;
        }

        const interval = setInterval(() => {
            setRemainingTimeMs(remainingTimeMs - 1000);
        }, 1000);

        // eslint-disable-next-line consistent-return
        return () => clearInterval(interval);
    }, [remainingTimeMs, onClose]);

    const countDownInSeconds = remainingTimeMs / 1000;

    return (
        <>
            <p className="remaining-time">{countDownInSeconds}</p>
            <p className="seconds-left">{messageSecondLeft}</p>
        </>
    );
};

interface CountdownDisplayProps {
    countdown: number | undefined;
    onClose: () => void;
    dictionary: SiteCoreDictionary;
}

const CountdownDisplay = ({ countdown, onClose, dictionary }: CountdownDisplayProps) => {
    if (typeof countdown === 'undefined') {
        return null;
    }

    return (
        <div className="countdown-container">
            <Countdown countdown={countdown} onClose={onClose} dictionary={dictionary} />
        </div>
    );
};

export default CountdownDisplay;
